import { render, staticRenderFns } from "./history.vue?vue&type=template&id=161ca27a"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=161ca27a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161ca27a')) {
      api.createRecord('161ca27a', component.options)
    } else {
      api.reload('161ca27a', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=161ca27a", function () {
      api.rerender('161ca27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/history.vue"
export default component.exports